// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from 'stimulus';
import { definitionsFromContext } from 'stimulus/webpack-helpers';
import { Autocomplete } from 'stimulus-autocomplete';
import HeaderStateController from 'controllers/frontend/header_state_controller';

const application = Application.start();
application.register('autocomplete', Autocomplete);
// The home/list_your_practice pages load this pack instead of the 'application' pack
// (see app/views/layouts/application.html.erb), so header-state must be registered here
// too or the header's Login/profile-menu slot never hydrates on those pages.
application.register('header-state', HeaderStateController);
const context = require.context('controllers/home', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
